import mutations from './mutations';
import getters from './getters';

export default {
    namespaced: true,
    state() {
        return {
            ad: {'init': true}
        }
    },
    mutations,
    getters
}